var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdgecoreIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#edgecore_icon_svg__clip0_3859_8762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.98.087H3v16h9.98v-16z",
    fill: "#221F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.484 12.129V4.002h4.969v1.39H7v1.937h3.453v1.39H7v2.02h3.453v1.39H5.484z",
    fill: "#E6003B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "edgecore_icon_svg__clip0_3859_8762"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzM4NTlfODc2MikiPgo8cGF0aCBkPSJNMTIuOTc5NCAwLjA4Njc5MkgzVjE2LjA4NjhIMTIuOTc5NFYwLjA4Njc5MloiIGZpbGw9IiMyMjFGMjAiLz4KPHBhdGggZD0iTTUuNDg0MTMgMTIuMTI5VjQuMDAyNUgxMC40NTI3VjUuMzkxNzVINi45OTk4M1Y3LjMyODk1SDEwLjQ1MjdWOC43MTgySDYuOTk5ODNWMTAuNzM4OEgxMC40NTI3VjEyLjEyODFINS40ODQxM1YxMi4xMjlaIiBmaWxsPSIjRTYwMDNCIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMzg1OV84NzYyIj4KPHJlY3Qgd2lkdGg9IjE2IiBoZWlnaHQ9IjE2IiBmaWxsPSJ3aGl0ZSIvPgo8L2NsaXBQYXRoPgo8L2RlZnM+Cjwvc3ZnPgo=";
export { SvgEdgecoreIcon as ReactComponent };